import { useState } from "react";
import { useAudioBlobUrl } from "../hooks/useAudioBlobUrl";
import { useChatFileUrl } from "../hooks/useChatFileUrl";
import { AudioPlayer } from "./AudioPlayer";

export interface ChatFileAudioProps {
  contentId: string;
  filename: string;
  className?: string;
}

export function ChatFileAudio({ contentId, filename, className }: ChatFileAudioProps) {
  const { data, isLoading, isError, refetch, isRefetching } = useChatFileUrl(contentId, {
    retry: 1,
  });
  const [attempt, setAttempt] = useState(0);
  const audio = useAudioBlobUrl(data?.url, attempt);
  return (
    <AudioPlayer
      src={audio.url}
      filename={filename}
      className={className}
      loading={isLoading || isRefetching || audio.loading}
      error={isError || audio.error || (!isLoading && !data)}
      onRetry={() => {
        setAttempt((value) => value + 1);
        void refetch();
      }}
    />
  );
}
